import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides CRUD operations on rematching operator and operator service journeys
 */
export class JourneyUpdateService {

  private operatorRematchResource: InterACT.Interfaces.IResource<any>;
  private operatorServiceRematchResource: InterACT.Interfaces.IResource<any>;

  constructor(
    private $resource: ng.resource.IResourceService,
    private resourceHelperService: ResourceHelperService) {
    this.operatorRematchResource = $resource('api/transport-operator-rematch-request');
    this.operatorServiceRematchResource = $resource('api/transport-operator-service-rematch-request');
  }

  /**
   * Makes a rematch request for a transport operator
   * @param operatorRematchRequestPayload rematch request payload
   *
   * @returns A http promise object
   */
  public rematchOperatorJourneys(operatorRematchRequestPayload: InterACT.Interfaces.JourneyUpdatesService.TransportOperatorRematchRequest) {
    return this.operatorRematchResource.save(operatorRematchRequestPayload).$promise;
  }

  /**
 * Makes a rematch request for a transport operator service
 * @param operatorServiceRematchRequestPayload rematch request payload
 *
 * @returns A http promise object
 */
  public rematchOperatorServiceJourneys(operatorServiceRematchRequestPayload: InterACT.Interfaces.JourneyUpdatesService.TransportOperatorServiceRematchRequest) {
    return this.operatorServiceRematchResource.save(operatorServiceRematchRequestPayload).$promise;
  }
}
